import styled from "styled-components";
import { COLORS } from "../const/colors";

export const SectionSubtitle = styled.span`
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.85rem;
  font-weight: 500;
  color: ${COLORS.DARK_BLUE};
  letter-spacing: 0.5px;
  margin: 0 auto 0.75rem;
  width: 100%;

  &::before,
  &::after {
    content: "";
    height: 1px;
    background-color: ${COLORS.ORANGE_50};
    flex-shrink: 0;
  }

  &::before {
    width: 30px;
    margin-right: 1rem;
  }

  &::after {
    width: 30px;
    margin-left: 1rem;
  }

  @media screen and (max-width: 576px) {
    &::before,
    &::after {
      width: 20px;
    }
  }
`;

export const SectionTitle = styled.h2`
  text-align: center;
  font-size: 2rem;
  font-weight: 700;
  background: linear-gradient(to right, ${COLORS.ORANGE}, ${COLORS.DARK_BLUE});
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  margin: 0 auto 2.5rem;
  position: relative;
  width: fit-content;

  &::after {
    content: "";
    position: absolute;
    width: 70px;
    height: 4px;
    background: linear-gradient(
      to right,
      ${COLORS.ORANGE},
      ${COLORS.ORANGE_50}
    );
    bottom: -10px;
    left: 50%;
    transform: translateX(-50%);
    border-radius: 2px;
  }

  @media screen and (min-width: 768px) {
    font-size: 2.25rem;

    &::after {
      width: 80px;
    }
  }
`;
